import React, { useState } from "react";

import { makeStyles } from '@material-ui/core/styles';

import Button from "../../../../base/buttons/button.js";
import TextField from "../../../../base/inputs/text_field.js.jsx";
import Checkbox from "../../../../base/inputs/checkbox.js";
import HtmlContent from "../../../../base/components/html_content.js";

import I18n from "../../../../base/i18n.js.jsx";

import Routes from "../../../routes.js";

const blockStyles = makeStyles(theme => ({
  button: {
    backgroundColor: theme.palette.white,
    color: theme.palette.blueMain,
    width: "100%",
    fontSize: "20px",
    padding: "12px 20px",
    ['@media (max-width: 768px)']: {
      fontSize: "16px",
      padding: "8px 20px",
    },
  },
  headline: {
    color: theme.palette.white,
    fontSize: "24px",
    lineHeight: "24px",
    paddingBottom: "20px",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderColor: theme.palette.grayDisable,
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      borderColor: theme.palette.blueMain,
    },
    "& .MuiInputBase-input": {
      fontSize: "16px",
      padding: "10px 12px",
      ['@media (max-width: 768px)']: {
        fontSize: "14px",
        padding: "12px 16px",
      }
    }
  },
  agreementContainer: {
    display: "flex",
    color: theme.palette.white,
    ['@media (max-width: 768px)']: {
      marginTop: "auto",
    },
  },
  agreementCheckbox: {
    marginLeft: "0px",
    marginTop: "5px"
  },
  agreement: {
    "& a": {
      color: `${theme.palette.white} !important`,
    },
    fontSize: "12px",
    lineHeight: "1.4",
    ['@media (max-width: 768px)']: {
      margin: "12px 0 24px",
      fontWeight: "600",
    },
  },
  root: {
    display: "flex",
    justifyContent: "center",
  },
  innerRoot: {
    backgroundColor: theme.palette.blueMain,
    padding: "20px",
    margin: "20px 0",
  },
  checkbox: {
    color: theme.palette.white
  }
}));

const SubscribeBlock = props => {
  const [agreement, setAgreement] = useState(false)

  const classes = blockStyles();

  const onChangeAgreement = (event) => {
    setAgreement(event)
  }

  const agreementDisplayName = <HtmlContent className = { classes.agreement } >
    { I18n.t("web.downloadable.agreement", {data_protection: Routes.dataProtection()}) }
  </HtmlContent>

  return (
    <div className = { classes.root } >
      <div className = { classes.innerRoot } >
        <form onSubmit = { props.subscribe }
              className = { classes.form } >
          <div className = { classes.headline }>{props.headline}</div>
          <TextField value = { props.subscribeEmail }
                    onChange = { props.setSubscribeEmail }
                    className = { classes.textField }
                    name = { "email" }
                    underline = { false }
                    type = { "email" }
                    variant = { "filled" }
                    displayNamePosition =  { "above" }
                    placeholder = { I18n.t("web.downloadable.email") }/>
          <div className = { classes.agreementContainer } >
            <Checkbox className = { classes.agreementCheckbox }
                      checkboxClass = { classes.checkbox }
                      displayName = { agreementDisplayName }
                      onChange = { onChangeAgreement } />
          </div>
          <Button type = { "submit" }
                  className = { classes.button }
                  disabled = { props.submitting || !agreement } >
                  { I18n.t("action.downloadable_optin") }
          </Button>
        </form>
      </div>
    </div>
  )
}

export default SubscribeBlock
